import React from 'react'
import { Portal as ChakraPortal } from '@chakra-ui/react'
import { forwardRef } from '@hub/design-system-base'

export interface PortalProps {
  containerRef?: React.RefObject<HTMLElement | null>
  appendToParentPortal?: boolean
}

// ref needs to be passed in for compatability but
// because portal doesn't have a DOM element we just throw it away
export const Portal = forwardRef<PortalProps, typeof ChakraPortal>(
  ({ containerRef, appendToParentPortal = false, children }, _ref) => (
    <ChakraPortal
      containerRef={containerRef}
      appendToParentPortal={appendToParentPortal}
    >
      {children}
    </ChakraPortal>
  )
)
